import { GetStaticProps, NextPage } from 'next';
import Link from 'next/link';

import MehOutlined from '@ant-design/icons/MehOutlined';

import Layout from '~components/ui/Layout';
import ShadowImage from '~components/ui/ShadowImage';
import { getFromAPI } from '~utils/api/common';
import normalizePromotions from '~utils/normalizers/normalizePromotions';

import { Promotion } from '~types';

import s from '~styles/pages/Promociones.module.css';

export const getStaticProps: GetStaticProps<{ promotions: Promotion[] }> = async () => {
  const promotions: Promotion[] = await getFromAPI('/promotions');

  return {
    props: {
      promotions: normalizePromotions(promotions),
    },
    revalidate: 60 * 60 * 24,
  };
};

interface Props {
  promotions: Promotion[];
}

const Promociones: NextPage<Props> = ({ promotions }) => {
  return (
    <Layout meta={{ title: 'Promociones' }} headerType="translucent">
      <div className={s.root}>
        {Boolean(Array.isArray(promotions) && promotions?.length) ? (
          <>
            <div className="mb-12 text-center">
              <h1 className="big-title">Promociones</h1>
              <p className="text-lg">Disfruta de las promociones que tenemos para ti</p>
            </div>
            <section className="w-full space-y-9 lg:space-y-20">
              {promotions?.map((promotion) => (
                <div key={promotion?.id} className="w-full">
                  {!!promotion?.image?.url && (
                    <Link href={`/promociones/${promotion?.slug}`} className="block">
                      <ShadowImage
                        data={promotion.image}
                        version="url"
                        className="aspect-video relative"
                        alt={promotion.title}
                      />
                    </Link>
                  )}
                </div>
              ))}
            </section>
          </>
        ) : (
          <div className="text-center max-w-[600px] py-24 mx-auto">
            <MehOutlined className="text-7xl text-gray-400 mb-12" />
            <h2 className="h2">Lo sentimos, en este momento no tenemos promociones para ti.</h2>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Promociones;
